import { Environment } from './model/environment.model';
/**
 * Its important that the values in this file are correctly overwritten during the deployment
 * process. The deployment process uses the file `assets/config.json` as the source of
 * truth for production values. If you change something here, make sure to also update
 * the corresponding values in the deployment process.
 *
 * Please use always fully qualified URLs (including the protocol and domain) for:
 * - backendUrl
 * - oauth.issuer
 * - oauth.redirectUri
 */
export const environment: Environment = {
  production: true,
  backendUrl: '/api',
  useMocks: false,
  oauth: {
    issuer: '/auth/realms/htx',
    clientId: 'htx-portal',
    redirectUri: '/',
    requireHttps: true
  }
};
